import '../globals';

;(function ($, location, _) {
    'use strict';

    var pluginName = 'requestArguments';

    function Plugin() {
        this._name = pluginName;
        this.requestArguments = {};
        this.fragment = '';
        this.init();

        return this;
    }

    $.extend(Plugin.prototype, {
        /**
         * Init
         */
        init: function () {
            this.parseUrl();
        },

        /**
         * Parse the URL and set the initial request arguments
         */
        parseUrl: function() {
            if (_.isEmpty(this.requestArguments)) {
                var requestArguments = {};
                var trimmedQueryString = _.trimStart(location.search, '?');
                var rawArguments = _.split(trimmedQueryString, '&');

                _.forEach(rawArguments, function (rawArgument) {
                    var argumentParts = _.split(rawArgument, '=');
                    var value = true;
                    if (argumentParts.length == 2) {
                        // Replace '+' with spaces and decode afterwords
                        value = decodeURIComponent(argumentParts[1].replace(/\+/g, '%20'));
                    }
                    var name = decodeURIComponent(_.first(argumentParts));
                    var nameParts = name.split('[');
                    // trim ']'
                    nameParts = _.map(nameParts, function (namePart) {
                        return _.trim(namePart, ']');
                    });
                    _.set(requestArguments, nameParts, value);
                });
                this.requestArguments = requestArguments;
            }
        },

        /**
         * Get request arguments
         *
         * @return object
         */
        getArguments: function() {
            return this.requestArguments;
        },

        /**
         * Get request argument
         *
         * @param argumentName
         * @param defaultValue
         * @return object
         */
        getArgument: function(argumentName, defaultValue) {
            return _.get(this.requestArguments, argumentName, defaultValue);
        },

        /**
         * Add an argument to request arguments
         *
         * @param argument
         * @param value
         */
        addArgument: function(argument, value) {
            if (_.isArray(value)) {
                value = _.join(value, '|');
            }
            _.set(this.requestArguments, argument, value);
        },

        removeArgument: function(argument) {
            _.unset(this.requestArguments, argument);
        },

        setFragment: function(fragment) {
            this.fragment = fragment;
        },

        /**
         * Redirect to arguments
         */
        redirectToArguments: function(alternativeLocation) {
            var queryStringElements = [];
            _.forEach(this.requestArguments, function(value, argumentName) {
                if (_.isString(value)) {
                    queryStringElements.push(argumentName + '=' + encodeURIComponent(value));
                } else {
                    _.forEach(value, function(value, subArgumentName) {
                        queryStringElements.push(argumentName + '[' + subArgumentName + ']=' + encodeURIComponent(value));
                    });
                }
            });

            var fragment = '';
            if (this.fragment !== '') {
                fragment = '#' + this.fragment;
            }

            if (_.isString(alternativeLocation)) {
                location.href = alternativeLocation + '?' + queryStringElements.join('&') + fragment;
            } else {
                location.href = location.origin + location.pathname + '?' + queryStringElements.join('&')  + fragment;
            }
        }
    });

    /**
     * Plugin wrapper
     */
    $.fn[pluginName] = function () {
        return new Plugin();
    };
})(jQuery, location, _);
